import { computed, signal } from '@preact/signals';

/**
 * "Revisar con Quique": global review mode. Pages with data traces register as review
 * surfaces; the top bar shows the switch only while one is mounted, and the mode applies
 * to every trace on screen. It replaces the toolbar each page used to render on its own.
 */
export const reviewMode = signal(false);

const surfaces = signal(0);

export const hasReviewSurface = computed(() => surfaces.value > 0);

/** Registers a review surface; returns the cleanup for `useEffect`. */
export function registerReviewSurface(): () => void {
  surfaces.value += 1;
  return () => {
    surfaces.value = Math.max(0, surfaces.value - 1);
  };
}

export function toggleReviewMode(): void {
  reviewMode.value = !reviewMode.value;
}
